module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMAgMAAAAfYnVoAAAADFBMVEX////39/fg4ODd3d3/JpsnAAAAMklEQVQI12OAgVoQwTjNAUiyOU4AkpIMKUAyBUgzME5gYHMAIhBDEiyYAlYAUsYG0Q4A64MGZF5wyw4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FLVersion/bubble.png
// module id = mPJl
// module chunks = 0